import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { ModalController, NavController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { UserService } from "src/app/_services";
import { ThisPlatform } from "../../_services/platform.service";
import { AppModule } from "../../_helpers/module";
import { User } from "src/app/_models/user.model";
import { SwiperComponent } from "swiper/angular";
@Component({
  selector: "app-first-run",
  templateUrl: "./first-run.page.html",
  styleUrls: [
    "./first-run.page.scss",
    "../../../../node_modules/swiper/swiper.scss",
    "../../../../node_modules/swiper/modules/pagination/pagination.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class FirstRunPage implements OnInit {
  @ViewChild("swiper", { static: false }) swiper?: SwiperComponent;

  constructor(
    private router: Router,
    public p: ThisPlatform,
    public modalController: ModalController,
    public translateService: TranslateService,
    public navController: NavController,
    public userServ: UserService
  ) {}

  public headers; // Przechowujemy tutaj nagłówki
  public texts; // Przechowujemy tutaj teksty
  public images;

  showPushAcceptance: boolean;

  userStorage: User;

  showFirstRun: boolean = false;
  lastSlide: boolean = false;

  hideSlider: boolean = false;

  slides: Array<any>;

  index = 0;

  async ngOnInit() {
    this.showPushAcceptance = !this.userServ.userStorage.pushAccepted;

    this.userStorage = JSON.parse(localStorage.getItem("currentUser"));

    this.slides = [
      {
        header: this.translateService.instant("FIRST_RUN.VIRTUAL_RECEPTION"),
        text: this.translateService.instant(
          "FIRST_RUN.VIRTUAL_RECEPTION_DESCRIPTION"
        ),
        imageMobile:
          "https://virtualreceptionfiles.blob.core.windows.net/assets/first-run/wirtualna-recepcja.png",
        imageDesktop:
          "https://virtualreceptionfiles.blob.core.windows.net/assets/first-run/kiosk-smartphone.png",
        mobileCircleBackground: false,
        moduleId: AppModule.Reception,
      },
      {
        header: this.translateService.instant("FIRST_RUN.REPORTING_DEFECTS"),
        text: this.translateService.instant(
          "FIRST_RUN.REPORTING_DEFECTS_DESCRIPTION"
        ),
        imageMobile:
          "https://virtualreceptionfiles.blob.core.windows.net/assets/first-run/zglaszanie-usterek.png",
        imageDesktop:
          "https://virtualreceptionfiles.blob.core.windows.net/assets/first-run/usterka.png",
        mobileCircleBackground: false,
        moduleId: AppModule.Reports,
      },
      {
        header: this.translateService.instant("FIRST_RUN.PARKING"),
        text: this.translateService.instant("FIRST_RUN.PARKING_DESCRIPTION"),
        imageMobile:
          "https://virtualreceptionfiles.blob.core.windows.net/assets/first-run/modul-parkingowy.png",
        imageDesktop:
          "https://virtualreceptionfiles.blob.core.windows.net/assets/first-run/modul-parkingowy.png",
        mobileCircleBackground: false,
        moduleId: AppModule.Parking,
      },
      {
        header: this.translateService.instant("FIRST_RUN.DESKS"),
        text: this.translateService.instant("FIRST_RUN.DESKS_DESCRIPTION"),
        imageMobile:
          "https://virtualreceptionfiles.blob.core.windows.net/assets/first-run/rezerwacja-biurek.png",
        imageDesktop:
          "https://virtualreceptionfiles.blob.core.windows.net/assets/first-run/rezerwacja-biurek.png",
        mobileCircleBackground: false,
        moduleId: AppModule.Desk,
      },
      {
        header: this.translateService.instant("FIRST_RUN.COMMUNITY"),
        text: this.translateService.instant("FIRST_RUN.COMMUNITY_DESCRIPTIONS"),
        imageMobile:
          "https://virtualreceptionfiles.blob.core.windows.net/assets/first-run/community.png",
        imageDesktop:
          "https://virtualreceptionfiles.blob.core.windows.net/assets/first-run/communityPC.png",
        mobileCircleBackground: false,
        moduleId: AppModule.Community,
      },
      {
        header: "Marketplace",
        text: this.translateService.instant(
          "FIRST_RUN.MARKETPLACE_DESCRIPTION"
        ),
        imageMobile:
          "https://virtualreceptionfiles.blob.core.windows.net/assets/first-run/marketplace.png",
        imageDesktop:
          "https://virtualreceptionfiles.blob.core.windows.net/assets/first-run/marketplacePC.png",
        mobileCircleBackground: true,
        moduleId: AppModule.Market,
      },
    ];

    if (this.userServ.userStorage.modules.length > 0) {
      this.slides = this.slides.filter((slide) => {
        return this.userServ.userStorage.modules.some((module) => {
          return slide.moduleId == module.idModule;
        });
      });
    }
  }

  firstRunPush(event) {
    if (event === true) {
      this.userServ
        .update(this.userServ.userStorage.id, {
          pushAccepted: true,
          firstRun: false,
        })
        .subscribe((e) => {
          this.userStorage.pushAccepted = true;
          localStorage.setItem("currentUser", JSON.stringify(this.userStorage));
          this.showPushAcceptance = false;
          this.navController.navigateRoot("app/home");
        });
    } else {
      this.showPushAcceptance = false;
      this.redirectToHome();
    }
  }

  progress(event) {
    let progress = event[1];
    if (progress > 1) {
      this.finishSliding();
    }
  }

  redirectToHome() {
    this.userServ
      .update(this.userServ.userStorage.id, { firstRun: false })
      .subscribe(() => {
        this.userStorage.firstRun = false;
        localStorage.setItem("currentUser", JSON.stringify(this.userStorage));
        this.navController.navigateRoot("app/home");
      });
  }

  finishSliding() {
    if (this.showPushAcceptance) {
      this.hideSlider = true;
    } else {
      this.redirectToHome();
    }
  }

  nextSlideMobile() {
    this.index++;
    if (this.index == this.slides.length + 1) {
      this.finishSliding();
    } else {
      this.swiper.swiperRef.slideNext();
    }
  }

  nextSlidePc() {
    if (this.index < this.slides.length - 1) {
      this.index++;
    } else {
      this.finishSliding();
    }
  }

  backSlideMobile() {
    this.index--;
    this.swiper.swiperRef.slidePrev();
  }

  backSlidePC() {
      this.index--;
  }
}
